import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6e3e495e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col w-full justify-center items-end mt-4" }
const _hoisted_2 = { class: "flex justify-center mt-2" }

import PrimaryButton from "./PrimaryButton.vue";
import { ref, watch } from "vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ButtonsAuth',
  props: {
  isLogging: Boolean,
},
  setup(__props) {

const props = __props;



const texts = [
  {
    text: "Login",
    routeName: "/login",
  },
  {
    text: "Recuperar conta",
    routeName: "retrieve-account",
  },
];

let mainItem = ref(texts[0]);
let secondaryItem = ref(texts[1]);

watch(
  () => props.isLogging,
  (isLogging) => {
    if (isLogging) {
      [mainItem.value, secondaryItem.value] = texts;
    } else {
      [secondaryItem.value, mainItem.value] = texts;
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PrimaryButton, {
      text: _unref(mainItem).text
    }, null, 8, ["text"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: _unref(secondaryItem).routeName,
        class: "text-[#002040] text-[12px] hover:text-[#355b81]"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(secondaryItem).text), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})